// extracted by mini-css-extract-plugin
export default {"container":"Campaigns_container__1Zkv4","header":"Campaigns_header__igEdT","rightSide":"Campaigns_rightSide__oQHtx"};